import './webpackPublicPath';
import React from 'react';
import ReactDOM from 'react-dom';
import * as MaterialUI from '@mui/material';
import * as MaterialUIStyles from '@mui/material/styles';
import * as EmotionReact from '@emotion/react';
import * as EmotionStyled from '@emotion/styled';

import WidgetLoader from './WidgetLoader';

declare global {
  interface Window {
    React: typeof React;
    ReactDOM: typeof ReactDOM;
    MaterialUI: typeof MaterialUI;
    MaterialUIStyles: typeof MaterialUIStyles;
    EmotionReact: typeof EmotionReact;
    EmotionStyled: typeof EmotionStyled;
  }
}

window.React = React;
window.ReactDOM = ReactDOM;
window.MaterialUI = MaterialUI;
window.MaterialUIStyles = MaterialUIStyles;
window.EmotionReact = EmotionReact;
window.EmotionStyled = EmotionStyled;

const widgets = document.getElementsByClassName('skoda-tools-widget');

function isHtmlElementWithDataset(element: any): element is HTMLElement {
  return element.dataset && typeof element.dataset === 'object';
}

for (let i = 0; i < widgets.length; i++) {
  const widget = widgets[i];

  if (!isHtmlElementWithDataset(widget)) {
    continue;
  }

  const moduleId = widget.dataset.moduleId;
  const src = widget.dataset.scriptSrc;
  if (!moduleId || !src || !widget.dataset.options) {
    continue;
  }

  let options: Record<any, unknown>;

  try {
    options = JSON.parse(widget.dataset.options);
  } catch (e) {
    continue;
  }

  ReactDOM.render(
    <React.StrictMode>
      <WidgetLoader
        module={moduleId}
        src={src}
        loadingMessage={widget.dataset.loadingMessage || '...'}
        // TODO: Remove console log
        onError={console.log}
        options={options}
      />
    </React.StrictMode>,
    widgets[i]
  );
}
